import {
  FormFieldsByUniqueID,
  SimpleFormField,
} from 'components/form/formTypes'
import { GeckoToggleForm } from 'components/form/GeckoToggleForm'
import React from 'react'
import { SubmitHandler } from 'react-hook-form'

interface DetectionModelFormProps {
  formFields: FormFieldsByUniqueID[]
  inEditMode: boolean
  onSubmit: SubmitHandler<SimpleFormField>
}

export const DetectionModelForm = React.forwardRef<
  HTMLFormElement,
  DetectionModelFormProps
>(({ formFields, inEditMode, onSubmit }, ref) => {
  return (
    <GeckoToggleForm
      formFieldsByUniqueID={formFields}
      inEditMode={inEditMode}
      onSubmit={onSubmit}
      ref={ref}
      numberOfColumns={1}
    />
  )
})

DetectionModelForm.displayName = 'DetectionModelForm'
